export var setThemeMode=function setThemeMode(mode){return{type:'SET_THEME_MODE',payload:{mode:mode}};};